import React from 'react'
import {MdInfoOutline} from 'react-icons/md'
import Notice from '@components/V3/Notice'
import useOrder from '@page-components/TrackV2/hooks/useOrder.main'
import {useTranslation} from 'next-i18next'

export interface Props {
  order: any
}

export default function DeliverySecretCode() {
  const {order} = useOrder()
  const {t} = useTranslation('tracking', {keyPrefix: 'deliveryVerificationCode'})

  if (!order.requiresDeliveryVerificationCode) return null

  return (
    <Notice level="info" className="flex items-center gap-2">
      <div className="w-8">
        <MdInfoOutline size={24} className="mr-2" />
      </div>
      <div>
        <div>{t('title')}</div>
        <div className="text-lg font-bold text-center">
          {order.requiresDeliveryVerificationCode}
        </div>
      </div>
    </Notice>
  )
}
